<template>
  <b-modal
    ref="modal"
    :title="selectedCulture.label"
    body-class="content-culture-description"
    hide-footer
  >
    <div class="value-icon-container">
      <img
        :src="imageUrl.replace('$ID$', selectedCulture.id)"
        class="value-icon"
      />
    </div>
    <p class="text-primary">
      <i
        v-if="
          isProbabilitySort
            ? selectedCulture.positionProbability <= 10
            : selectedCulture.position <= 10
        "
        class="material-icons text-warning"
      >
        emoji_events
      </i>
      <span class="mr-2">
        {{
          isProbabilitySort
            ? selectedCulture.positionProbability
            : selectedCulture.position
        }}&deg;
      </span>
      <b>{{ selectedCulture.label }}</b>
      {{
        selectedCulture.desiredValue ? `(${selectedCulture.desiredValue})` : ''
      }}
      <span class="maturity-level">
        <b-badge pill variant="gray00" class="float-right"
          >{{ labels.level }} {{ selectedCulture.level }}</b-badge
        >
      </span>
    </p>
    <p v-if="selectedCulture.unfavorable" class="text-secondary unfavorable">
      {{ labels.limiting }}
    </p>
    <p class="value-description">{{ selectedCulture.description }}</p>
    <VueApexCharts
      type="line"
      height="350px"
      class="text-primary"
      :options="selectedCulture.options"
      :series="selectedCulture.series"
    />
    <p class="text-primary">
      <span v-if="selectedCulture.seen === 1">
        {{ labels.user | parse({ COUNT: selectedCulture.seen }) }} |
      </span>
      <span v-else>
        {{ labels.users | parse({ COUNT: selectedCulture.seen }) }} |
      </span>
      {{ selectedCulture.votes }}
      {{ selectedCulture.votes === 1 ? labels.vote : labels.votes }} |
      <span>{{ labels.probability }} {{ selectedCulture.probability }}%</span>
    </p>
    <p class="text-primary reliability-rate">
      {{ labels.reliabilityRate }} :
      <span
        v-if="selectedCulture.reliabilityRate"
        :class="selectedCulture.reliabilityRate"
      >
        {{ labels.scaleDescriptions[selectedCulture.reliabilityRate] }}
      </span>
    </p>
  </b-modal>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { mapGetters } from 'vuex'

const props = {
  selectedCulture: {
    type: Object,
    default: {},
  },
  imageUrl: {
    type: String,
  },
  isProbabilitySort: {
    type: Boolean,
  },
}

export default {
  props,
  components: { VueApexCharts },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.culture.valuesModal
    },
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.unfavorable {
  font-size: 10pt;
  font-weight: bold;
  margin-left: 2%;
  margin-right: 2%;
}

.reliability-rate {
  font-size: 11pt;

  .high {
    color: map-get($theme-colors, 'metric-high');
  }
  .medium {
    color: map-get($theme-colors, 'metric-medium');
  }
  .low {
    color: map-get($theme-colors, 'red02');
  }
  .veryLow {
    color: map-get($theme-colors, 'metric-low');
  }
}

.value-icon-container {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 25px;

  .value-icon {
    height: 250px;
  }
}

.value-description {
  font-style: italic;
  color: map-get($theme-colors, 'gray02');
}
</style>
